import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Search, Briefcase, ArrowRight } from 'lucide-react';
import axios from 'axios';
import '../../../../assets/css/screens/customer/dashboard/appservices/AppServices.css';
import { useServiceWorkerContext } from '../../../../context/workercontext/WorkerContext';
import ServiceCard from '../../../../components/customer/services/servicecards/ServiceCards';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import AppContext from '../../../../context/AppContext';

const AllServices = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [services, setServices] = useState([]);

  const { setSelectedWorker } = useServiceWorkerContext();


  const {baseUrl, baseUrlForFile} = useContext(AppContext);


  // Fetch categories from admin panel
 const fetchCategories = () => {
  const authToken = localStorage.getItem('authToken');

  axios
    .get(`${baseUrl}/customer/viewcategories`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    })
    .then((response) => {
      console.log("API RESPONSE:", response.data);

      setServices(response.data.categories || []);
    })
    .catch((error) => {
      console.log(error);
    });
};

  useEffect(() => {
    fetchCategories();
  }, []);

  // Search filter
  const filtered = services.filter((service) =>
    service.categoryName.toLowerCase().includes(search.toLowerCase())
  );

const handleClick = (service) => {
  navigate("/post-a-job", {
    state: {
      category: {
        id: service.id,
        categoryName: service.name,
      },
    },
  });
};

  return (
    <>
      <AppNavbar />

      <div className="asv-page">

        {/* Mobile header */}
        <div className="asv-mobile-header">
          <button className="asv-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={22} />
          </button>

          <h2 className="asv-mobile-title">All Categories</h2>
        </div>

        {/* Search */}
        <div className="asv-search-wrap">
          <div className="asv-search">
            <Search size={17} />

            <input
              type="text"
              placeholder="Search categories..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        {/* Grid */}
        <div className="asv-grid">
          {filtered.map((service, i) => (
            <ServiceCard
  key={service.id}
  index={i}
  onClick={handleClick}
  item={{
    id: service.id,
    name: service.categoryName,
    description: service.description,

   image: `${baseUrlForFile}/${service.categoryImage}`,

  }}
/>
          ))}

          {filtered.length === 0 && (
            <div className="asv-empty">
              <Search size={36} />
              <p>No categories found</p>
            </div>
          )}
        </div>

        {/* Can't find your service section */}
      <div className="asv-post-section">
  <div className="asv-post-card">

    <div className="asv-post-card__icon">
      <Briefcase size={28} />
    </div>

    <div className="asv-post-card__text">

      <h3 className="asv-post-card__title">
        Need a Service Expert?
      </h3>

      <p className="asv-post-card__desc">
        Tell us what you need and connect with skilled workers for reliable home services at your doorstep.
      </p>

    </div>

    <button
      className="asv-post-card__btn"
      onClick={() => navigate('/post-a-job')}
    >
      Post a Job <ArrowRight size={16} />
    </button>

  </div>
</div>

      </div>
    </>
  );
};

export default AllServices;